import { render, staticRenderFns } from "./FundSituation.vue?vue&type=template&id=23b97432&scoped=true&"
import script from "./FundSituation.vue?vue&type=script&lang=js&"
export * from "./FundSituation.vue?vue&type=script&lang=js&"
import style0 from "./FundSituation.vue?vue&type=style&index=0&id=23b97432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b97432",
  null
  
)

export default component.exports